module.exports = __webpack_public_path__ + "media/applicants/app-store-fr-d59010fc.png";